import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ca-span',
  templateUrl: './ca-span.component.html',
  styleUrls: ['./ca-span.component.scss']
})
export class CaSpanComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
